import { useParams, useSearchParams } from "react-router-dom";
import { Download, Loader2, Save } from "lucide-react";
import { PageHeader } from "@/pages/admin/AdminLayout";
import { QuoteItems } from "@/pages/admin/QuoteItems";
import { QuoteSummary } from "@/pages/admin/QuoteSummary";
import { quotePayload, quoteTotals, useQuoteForm } from "@/pages/admin/useQuoteForm";
import { generateQuotePdf } from "@/lib/quotePdf";

const field = "h-10 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm outline-none focus:border-emerald-500";

export default function QuoteEditor() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const { q, setQ, saving, save } = useQuoteForm(id, params.get("lead"));

  if (!q) return <Loader2 className="h-6 w-6 animate-spin text-slate-400" />;
  const set = (k) => (e) => setQ({ ...q, [k]: e.target.value });
  const totals = quoteTotals(q);
  const downloadPdf = () => generateQuotePdf({ ...quotePayload(q), number: q.number || "BOZZA", created_at: q.created_at,
    subtotal: totals.subtotal, vat_amount: totals.vat, total: totals.total });

  return (
    <div data-testid="admin-quote-editor">
      <PageHeader title={q.number ? `Preventivo ${q.number}` : "Nuovo preventivo"} subtitle="Prezzi e voci sono inseriti da te">
        <div className="flex gap-2">
          <button data-testid="admin-download-pdf-button" onClick={downloadPdf}
            className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium hover:border-slate-900"><Download className="h-4 w-4" /> PDF</button>
          <button data-testid="quote-save-button" onClick={save} disabled={saving} className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-emerald-500 hover:text-slate-900 disabled:opacity-60">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Salva
          </button>
        </div>
      </PageHeader>
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-2">
          <div className="grid gap-3 rounded-2xl border border-slate-200 bg-white p-5 sm:grid-cols-2">
            <input data-testid="quote-customer-name-input" className={field} placeholder="Nome cliente *" value={q.customer_name} onChange={set("customer_name")} />
            <input data-testid="quote-customer-phone-input" className={field} placeholder="Telefono" value={q.customer_phone} onChange={set("customer_phone")} />
            <input data-testid="quote-customer-email-input" className={field} placeholder="Email" value={q.customer_email} onChange={set("customer_email")} />
            <input data-testid="quote-customer-address-input" className={field} placeholder="Indirizzo impianto" value={q.customer_address} onChange={set("customer_address")} />
          </div>
          <QuoteItems items={q.items} onChange={(items) => setQ({ ...q, items })} />
          <textarea data-testid="quote-notes-input" rows={4} value={q.notes} onChange={set("notes")} placeholder="Note e condizioni (tempi, pagamento, validità offerta…)"
            className="w-full rounded-2xl border border-slate-200 bg-white p-4 text-sm outline-none focus:border-emerald-500" />
        </div>
        <QuoteSummary q={q} setQ={setQ} totals={totals} />
      </div>
    </div>
  );
}
